import { useCallback, useMemo } from "react";
import { isNil, omitBy } from "lodash";

import { getNextQueryParams } from "components/helpers";
import { ModalTable } from "components/BaseTableV3/ModalTable";
import { useDialSessionContactsTable } from "hooks/useDialSessionContactsTable";
import CallQueueService from "services/CallQueue";

export const DIAL_SESSION_CONTACTS_TABLE_CONSTANTS = {
  tableName: "dial_session_contacts",
  queryKey: "dial-session-contacts",
  className: "Contact",
  exportTableName: "DialSessionContactsTable",
  header: "Contacts",
  headerIcon: "user",
};

const DialSessionContactsTableV3 = ({
  dialSessionId = null,
  total = null,
  isUrgent = null,
  isCallable = null,
}) => {
  const defaultQueryParams = useMemo(
    () =>
      omitBy(
        {
          dial_session_id: dialSessionId,
          total: total,
          urgent: isUrgent,
          callable: isCallable,
        },
        isNil
      ),
    [dialSessionId, total, isUrgent, isCallable]
  );

  const { columns, queryKey } = useDialSessionContactsTable({ dialSessionId });

  const fetchContacts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(
          { ...queryParams, ...defaultQueryParams },
          columns
        );

        const response = await CallQueueService.getContacts(nextQueryParams);
        return response;
      } catch (error) {
        console.error("Error fetching contacts:", error);
        throw error;
      }
    },
    [columns, defaultQueryParams]
  );

  return (
    <ModalTable
      headerIcon={DIAL_SESSION_CONTACTS_TABLE_CONSTANTS.headerIcon}
      header={DIAL_SESSION_CONTACTS_TABLE_CONSTANTS.header}
      columns={columns}
      fetchData={fetchContacts}
      queryKey={queryKey}
      enableSearch
    />
  );
};

export default DialSessionContactsTableV3;
